export default __webpack_public_path__ + "static/media/biodata-1.b4228641.png";